import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=a153648c&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Service.vue?vue&type=style&index=1&id=a153648c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a153648c",
  null
  
)

export default component.exports